import React, { useState } from "react";
import "./IPManager.css";

export default function IPManager() {
  const [formData, setFormData] = useState({
    searchIP: "",
    ipAddress: "",
    whitelist: false,
    blacklist: false,
    maxLimit: "",
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSaveIP = () => {
    console.log("IP Saved:", formData);
  };

  const handleSaveLimit = () => {
    console.log("Max Limit Saved:", formData.maxLimit);
  };

  return (
    <div className="ip-page">
      {/* Header */}
      <div className="ip-header">
        <h2>IP Manager</h2>
        <div className="breadcrumb">
          <a href="/">Home</a>
        </div>
      </div>

      {/* Alert */}
      <div className="alert-box">
        Max Registration Limit: <span>5</span>
      </div>

      {/* Search Input */}
      <div className="form-row">
        <input
          type="text"
          name="searchIP"
          placeholder="Search IP..."
          value={formData.searchIP}
          onChange={handleChange}
        />
      </div>

      {/* IP + Whitelist/Blacklist */}
      <div className="form-row">
        <input
          type="text"
          name="ipAddress"
          placeholder="Enter IP Address"
          value={formData.ipAddress}
          onChange={handleChange}
        />
        <label>
          <input
            type="checkbox"
            name="whitelist"
            checked={formData.whitelist}
            onChange={handleChange}
          />
          Whitelist IP
        </label>
        <label>
          <input
            type="checkbox"
            name="blacklist"
            checked={formData.blacklist}
            onChange={handleChange}
          />
          Blacklist IP
        </label>
        <button className="btn save" onClick={handleSaveIP}>
          Save IP
        </button>
      </div>

      {/* Max Limit */}
      <div className="form-row">
        <input
          type="text"
          name="maxLimit"
          placeholder="Enter max Registration limit"
          value={formData.maxLimit}
          onChange={handleChange}
        />
        <button className="btn save" onClick={handleSaveLimit}>
          Save
        </button>
      </div>

      {/* Table */}
      <table className="ip-table">
        <thead>
          <tr>
            <th>#</th>
            <th>IP Address</th>
            <th>Device ID</th>
            <th>Whitelisted	</th>
            <th>Blacklisted</th>
            <th>Last Used At</th>
            <th>Email</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan="3" style={{ textAlign: "center", color: "#888" }}>
              No Data Found
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

